export default __webpack_public_path__ + "static/media/Triplei.f075f9f3.png";